import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useCustomerEnrichApiKeyDelete } from 'features/customers/hooks/useCustomerEnrichApiKeyDelete'

type DeleteEnrichApiKeyModalProps = {
  onClose: (...args: any[]) => any
}

const DeleteEnrichApiKeyModal = ({ onClose }: DeleteEnrichApiKeyModalProps) => {
  const { deleteEnrichApiKey, isPending: isLoading } = useCustomerEnrichApiKeyDelete()

  const onConfirm = async () => {
    deleteEnrichApiKey()
    onClose()
  }

  return (
    <Dialog onClose={onClose} open>
      <DialogTitle>Delete Key</DialogTitle>
      <DialogContent style={{ width: 500 }}>
        <DialogContentText>
          Are you sure? This will remove all Enrich API access and limits for this customer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button autoFocus color="primary" loading={isLoading} onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteEnrichApiKeyModal
